var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.expedientHasStages
    ? _c(
        "v-menu",
        {
          attrs: {
            bottom: "",
            "close-on-content-click": true,
            "nudge-bottom": "42",
            "nudge-right": "34",
            "content-class": "stage-selector-wrapper",
          },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function ({ on, attrs }) {
                  return [
                    _c(
                      "div",
                      _vm._g(
                        _vm._b(
                          { staticClass: "filter-button" },
                          "div",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [
                        _c("span", {
                          class: [_setup.renderedIcon, "lf-icon__md"],
                        }),
                        _c("span", { staticClass: "filter-text" }, [
                          _vm._v(_vm._s(_setup.title)),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ],
            null,
            false,
            3054728420
          ),
        },
        [
          _c(_setup.LfRadioGroupComponent, {
            attrs: {
              value: _setup.selectedStageId,
              options: _setup.finalItems,
              itemKey: "id",
              itemText: "stage",
            },
            on: { "update-value": _setup.setState },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ item }) {
                    return [
                      Number(item.current)
                        ? _c(
                            _setup.LexonTooltipComponent,
                            {
                              attrs: {
                                message: _setup.texts.currentStage,
                                position: "top",
                              },
                            },
                            [
                              _c("div", {
                                staticClass: "actual-stage-bullet",
                                attrs: { slot: "activator-element" },
                                slot: "activator-element",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              false,
              2226956397
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }